/**
 * Created by rhampton on 2/28/14.
 */
angular.module('services.httpService', []);